// @flow
import React from 'react';

import JobLogGroupStore from 'app/stores/JobLogGroupStore';

import JobLogOutputHeader from './Header';
import JobLogOutputLine from './Line';

const getStateFromStores = (id) => ({ expanded: JobLogGroupStore.isExpanded(id) });

type Props = {
  id: string,
  name: ?string,
  lines: Array<{
    id: string,
    number: number,
    line: string
  }>,
  number: number,
  startedAt: ?string,
  finishedAt: ?string,
  durationPercentage: ?number,
  bootstrap?: boolean
};

type State = {
  expanded: boolean
};

export default class JobLogOutputGroup extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = getStateFromStores(props.id);
  }

  componentDidMount() {
    JobLogGroupStore.addChangeListener(this.props.id, this.handleStoreChange);
  }

  componentWillUnmount() {
    JobLogGroupStore.removeChangeListener(this.props.id, this.handleStoreChange);
  }

  handleStoreChange = () => {
    this.setState(getStateFromStores(this.props.id));
  };

  constructLineNodes() {
    return this.props.lines.map((line) => (
      <JobLogOutputLine key={line.id} {...line} />
    ));
  }

  render() {
    // If we have a name, then show it as a collapsable group, otherwise just
    // dump all the lines in there.
    if (this.props.name) {
      const { name, lines: _lines, ...remainder } = this.props;

      return (
        <tbody>
          <JobLogOutputHeader
            {...remainder}
            name={name}
          />
          {this.state.expanded && this.constructLineNodes()}
        </tbody>
      );
    }

    return (
      <tbody>
        {this.constructLineNodes()}
      </tbody>
    );
  }
}
